import axios from 'axios';
import {
  LRS_VERB_COMPLETED, LRS_VERB_CONSUMED, LRS_VERB_STARTED, LRS_VERB_VIEWED,
} from '../common/constants';

import chunkArray from '../common/chunkArray';

// eslint-disable-next-line import/prefer-default-export
export const generateLRSConsumerCalls = ({
  recordList, appVersion, uid, postURL, typeList, oa2Token,
}) => {
  const recordChunks = chunkArray(recordList, 25);
  // If no chunks requested push an empty array into the chunks
  if (!recordChunks.length) {
    recordChunks.push([]);
  }

  return recordChunks.map((chunkList) => axios
    .post(postURL, {
      userid: uid,
      objectIds: chunkList,
      objectTypes: typeList,
      verbTypes: [
        LRS_VERB_CONSUMED,
        LRS_VERB_STARTED,
        LRS_VERB_COMPLETED,
        LRS_VERB_VIEWED,
      ],
    // latestOnly: true,
    }, {
      headers: {
        Authorization: `Bearer ${oa2Token}`,
        'X-GnosisVersion': appVersion,
      },
    })
    .then((res) => res.data));
};
